import {
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  UNAUTHORIZED_USER,
  FORBIDDEN_ACTION,
} from "../types/authTypes";
import {
  SET_DT_REDUCER,
  TABLE_DATA_FETCH_SUCCESS,
  TABLE_DATA_LOADING,
  TABLE_DATA_RESET,
} from "../types/dtType";

const initState = {};

const dtReducer = (state = initState, action) => {
  switch (action.type) {
    case TABLE_DATA_LOADING:
      return (action.limit && !action.offset) ||
        (!action.limit && !action.offset)
        ? {
            ...state,
            [action.id]: {
              loading: true,
              success: false,
              error: false,
              totalRecords: 0,
              rows: [],
            },
          }
        : state;
    case TABLE_DATA_FETCH_SUCCESS:
      let mergedData = !action.limit
        ? action.payload?.rows
        : getMergeData(
            state[action.id] ? [...state[action.id].rows] : null,
            action.payload?.rows,
          );

      return {
        ...state,
        [action.id]: {
          loading: false,
          success: true,
          error: false,
          totalRecords: action.payload?.totalRecords,
          rows: mergedData,
        },
      };
    case TABLE_DATA_RESET:
      return {
        ...state,
        [action.id]: {
          totalRecords: 0,
          rows: [],
        },
      };
    case SET_DT_REDUCER:
      return {
        ...state,
        ...(action.payload || {}),
      };
    case LOGOUT_SUCCESS:
    case LOGOUT_ERROR:
    case UNAUTHORIZED_USER:
    case FORBIDDEN_ACTION:
      return initState;
    default:
      return state;
  }
};

export default dtReducer;

const getMergeData = (stateData, curData) => {
  if (stateData) {
    let mergedData = stateData;
    for (let i = 0; i < curData?.length; i++) {
      let flag = false;
      for (let j = 0; j < stateData?.length; j++) {
        if (stateData[j].id === curData[i].id) {
          flag = true;
        }
      }
      if (!flag) {
        mergedData.push(curData[i]);
      }
    }
    mergedData.sort((a, b) => b.updatedAt - a.updatedAt);
    console.log("merged data ", mergedData);
    return mergedData;
  } else {
    return curData;
  }
};
